import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { carouselSettingShape } from '@bibliocommons/bc-prop-types';
import CatalogueCarousel from '@bibliocommons/catalogue-carousel';
import { convertLegacyIdToMetadataId } from '@bibliocommons/utils-link';

import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import { METADATA_CATEGORY_TYPE } from 'app/constants/AnalyticsGa4Constants';

const WrappedCatalogueCarousel = props => {
  const dispatch = useDispatch();

  const trackJacketClick = (bib, carouselTitle) => {
    const containerTitle = props?.containerName ?? carouselTitle;

    dispatch(
      trackContentClick({
        bib: {
          bib_audience: bib?.bib?.audience,
          bib_fiction_type: bib?.bib?.fiction_type,
          bib_format: bib?.bib?.format ?? bib?.format,
          bib_bib_fulfillment_provider: bib?.bib?.fulfillment_provider,
          bib_group_key: bib?.bib?.group_key,
          bib_metadata_id: bib?.bib?.metadata_id ?? convertLegacyIdToMetadataId(bib.id)
        },
        metadata: {
          metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_TITLE,
          metadata_value: bib?.title
        },
        ui: {
          ui_component_type: 'link-image',
          ui_container_title: containerTitle,
          ui_container_type: 'carousel'
        }
      })
    );
  };

  return <CatalogueCarousel {...props} onJacketClick={trackJacketClick} />;
};

WrappedCatalogueCarousel.propTypes = {
  bibs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      format: PropTypes.string.isRequired,
      jacket: PropTypes.shape({
        medium: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  ),
  carouselSettings: carouselSettingShape,
  carouselTitle: PropTypes.string.isRequired,
  carouselTitleLink: PropTypes.string,
  containerName: PropTypes.string,
  domain: PropTypes.string,
  headingTag: PropTypes.string
};

export default WrappedCatalogueCarousel;
